// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__27hYo","col":"styles_col__pOAYL"};